/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Doc_Mental_Health_TitleInputs */

const en_faq_doc_mental_health_title = /** @type {(inputs: Faq_Doc_Mental_Health_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mental Health Guide`)
};

const fr_faq_doc_mental_health_title = /** @type {(inputs: Faq_Doc_Mental_Health_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide de santé mentale`)
};

/**
* | output |
* | --- |
* | "Mental Health Guide" |
*
* @param {Faq_Doc_Mental_Health_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const faq_doc_mental_health_title = /** @type {((inputs?: Faq_Doc_Mental_Health_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Doc_Mental_Health_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_doc_mental_health_title(inputs)
	return fr_faq_doc_mental_health_title(inputs)
});